/**
 * Debug utility for viewing webhook logs that persist across redirects
 */

export function getWebhookLogs(): any[] {
  try {
    return JSON.parse(sessionStorage.getItem('webhookLogs') || '[]');
  } catch {
    return [];
  }
}

export function clearWebhookLogs(): void {
  sessionStorage.removeItem('webhookLogs');
}

export function printWebhookLogs(): void {
  const logs = getWebhookLogs();
  console.log('=== WEBHOOK DEBUG LOGS ===');
  logs.forEach((log, index) => {
    console.log(`${index + 1}. [${log.timestamp}] ${log.message}`, log.data);
  });
  console.log('=== END WEBHOOK LOGS ===');
}

// Make it available globally for easy debugging
(window as any).debugWebhooks = {
  getLogs: getWebhookLogs,
  clearLogs: clearWebhookLogs,
  printLogs: printWebhookLogs,
};
